import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextoVisualizacao = _resolveComponent("TextoVisualizacao")!
  const _component_TextoEdicao = _resolveComponent("TextoEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.texto.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_TextoVisualizacao, {
          key: 0,
          texto: _ctx.texto,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir,
          onSelecionar: _ctx.selecionar
        }, null, 8, ["texto", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir", "onSelecionar"]))
      : _createCommentVNode("", true),
    (_ctx.texto.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_TextoEdicao, {
          key: 1,
          texto: (_ctx.texto as TextoEditavel)
        }, null, 8, ["texto"]))
      : _createCommentVNode("", true)
  ]))
}